export const SERVICE_TYPE_MAP: Record<string, Record<string, string>> = {
  trademark: {
    'registration': '商标注册',
    'transactions': '商标交易',
    'extension': '商标延期申请',
    'postpone_evidence': '意向申请提交证据',
    'transfer': '商标仅转让',
    'review': '商标复审',
    'revocation': '商标提异议撤销无效',
    'search': '商标检索',
    'oath': '商标宣誓',
    'renewal': '商标续展',
    'agency_transfer': '商标转代理',
    'cancellation': '商标注销',
    'certificate_reissue': '商标补证书',
    'information_changes': '商标信息变更',
    'investment': '商标投资',
  },
  patent: {
    'appearance_application': '外观专利申请',
    'invention_application': '发明专利申请',
    'utility_application': '实用新型专利申请',
    'authorization': '专利授权',
    'rejection_review': '专利驳回复审',
  },
  copyright: {
    'registration': '版权注册',
    'transfer': '版权转让',
  },
  company: {
    'registration': '公司注册',
    'annual_review': '公司年审',
    'bank_account_opening': '公司开户',
    'information_changes': '公司信息变更',
    'cancellation': '公司注销',
    'audit': '审计',
  },
  barcode: {
    'registration': '条形码注册',
    'renewal': '条形码续费',
    'cancellation': '条形码注销',
    'increase': '条形码增码',
  },
  other: {
    'registration': '其他注册业务',
    'cancellation': '其他注销业务',
  },
};
